import { Color } from '@kite-js/theme-types';

const blue: Color = {
    50: '#eef4ff',
    100: '#cfdaff',
    200: '#89a0f1',
    300: '#000cc0',
    400: '#000991',
    500: '#000066',
};

export default blue;
